import React from 'react';
import { useTranslation } from 'react-i18next';
import LazyLoad from 'react-lazyload';
import DeviceUnknownIcon from '@material-ui/icons/DeviceUnknown';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import LoopIcon from '@material-ui/icons/Loop';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SvgCircle from '../components/svgCircle';

const About = () => {

   const { t } = useTranslation();

   return (
      <section id="about" className="about">
         <div className="about-decor">
            <div className="about-circle1 circle-shadow">
               <SvgCircle color1="#F3E63E" color2="#F3E63E" r1="40" r2="7" />
               {/*                <LazyLoad>
                  <img src="assets/images/team1.png" alt="team1" />
               </LazyLoad> */}
            </div>
            <div className="about-circle2 circle-shadow">
               <LazyLoad>
                  <img src="assets/images/ourmind-logo-head.png" alt="banner1" />
               </LazyLoad>
            </div>
         </div>
         <div className="container">
            <div className="row ">
               <div className="col-md-6">
                  <div className="about-contain">
                     <div style={{zIndex: 1}}>
                        <h2 className="title pink-title text-center text-md-left"><span>ourmind</span> {t('is the expert')}</h2>
                        <p className="caption-about mb-5">{t('about ourmind')}</p>
                        <div className="row">
                           <div className="mb-5 mb-md-4 col-md-6 d-flex">
                              {/* <div className="row"> */}
                              <div className="col-2 d-flex align-items-center justify-content-center">
                                 <DeviceUnknownIcon className="mat-ui-icon large" />
                              </div>
                              <div className="col-10 d-flex align-items-center text-left text-wrap ">
                                 {t('some think they know, some have ourmind')}
                              </div>
                              {/* </div> */}
                           </div>
                           <div className="mb-5 mb-md-4 col-md-6 d-flex">
                              {/* <div className="row"> */}
                              <div className="col-2 d-flex align-items-center justify-content-center">
                                 <EmojiObjectsIcon className="mat-ui-icon large" />
                              </div>
                              <div className="col-10 d-flex align-items-center text-left text-wrap">
                                 {t('your virtual problem solver')}
                              </div>
                              {/* </div> */}
                           </div>
                        </div>
                        <div className="row">
                           <div className="mb-5 mb-md-4 col-md-6 d-flex">
                              {/* <div className="row"> */}
                              <div className="col-2 d-flex align-items-center justify-content-center">
                                 <LoopIcon className="mat-ui-icon large" />
                              </div>
                              <div className="col-10 d-flex align-items-center text-left text-wrap ">
                                 {t('up to date digital knowledge base')}
                              </div>
                              {/* </div> */}
                           </div>
                           <div className="mb-5 mb-md-4 col-md-6 d-flex">
                              {/* <div className="row"> */}
                              <div className="col-2 d-flex align-items-center justify-content-center">
                                 <CheckCircleIcon className="mat-ui-icon large" />
                              </div>
                              <div className="col-10 d-flex align-items-center text-left text-wrap">
                                 {t('one question one answer')}
                              </div>
                              {/* </div> */}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="col-md-6 d-medium-none">
                  <div className="about-right">
                     <div className="about-right-slogan">"{t('phone slogan')}"</div>
                     <div className="about-phone">
                        <LazyLoad><img src="assets/images/phone-ourmind.png" className="img-fluid" alt="aboutus" /></LazyLoad>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}


export default About;


// WEBPACK FOOTER //
// ./src/components/about.js